import React, { useState, useRef, lazy } from "react";

/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import SidebarModel from "../../../components/ui/sidebarModel/SidebarModel";

/** Common Services & Data files  */
import { AppIcons } from "../../../data/appIcons";

/** Configuration files  */
import { addDocumentField } from "./components/addDocument.formfield.config";

/** Lazily Loaded Components  */
const AddDocument = lazy(() => import("./components/AddDocument"));
const DocumentList = lazy(() => import("./components/DocumentList"));

const Documents = (props) => {
  const molGridList = useRef();

  const [documentData, setDocumentData] = useState(
    addDocumentField.initialState
  ); // Initialize craft data with initialCraftState.
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const resetForm = () => {
    let formData = { ...documentData };
    setDocumentData(formData);
  };

  const onSuccess = () => {
    onSidebarClose();
    molGridList.current.refreshGrid();
  };

  const handleAddClick = () => {
    resetForm();
    setIsEdit(false);
    setIsModelOpen(true);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    setDocumentData(data);
    setIsModelOpen(true);
  };

  const onSidebarClose = () => {
    resetForm();
    setIsEdit(false);
    setIsModelOpen(false);
    setDocumentData(addDocumentField.initialState);
  };

  return (
    <>
      <div className="client-section document-inner-sec">
        <div className="main-tab-section">
          <CardSection
            cardTitle="Documents"
            isButtonVisible={true}
            titleButtonClick={handleAddClick}
            rightButton={true}
            buttonClassName="blue-btn"
            buttonText="Add"
          >
            <DocumentList
              ref={molGridList}
              onEdit={handleEditClick}
              {...props}
            />
          </CardSection>
        </div>
      </div>

      <SidebarModel
        isOpen={isModelOpen}
        onClose={onSidebarClose}
        contentClass="content-50"
        modalTitleIcon={AppIcons.AddIcon}
        modalTitle={`${isEdit ? "Update" : "Add"} Document`}
      >
        <AddDocument
          isEdit={isEdit}
          initData={documentData}
          onReset={resetForm}
          onClose={onSidebarClose}
          onSuccess={onSuccess}
          {...props}
        />
      </SidebarModel>
    </>
  );
};

export default Documents;
